import React, { useState, useEffect } from 'react';

interface ActionBarProps {
  selectAll: boolean;
  isIndeterminate: boolean;
  onUpdateSelectAll: (value: boolean) => void;
  className?: string;
}

const ActionBar: React.FC<ActionBarProps> = ({
  selectAll,
  isIndeterminate,
  onUpdateSelectAll,
  className = 'px-4'
}) => {
  const [currentSelectAll, setCurrentSelectAll] = useState(false);

  useEffect(() => {
    setCurrentSelectAll(selectAll);
  }, [selectAll]);

  const handleSelectAllChange = (checked: boolean) => {
    setCurrentSelectAll(checked);
    onUpdateSelectAll(checked);
  };

  return (
    <div className={`absolute bottom-0 left-0 right-0 rounded-lg ${className}`}>
      <div>
        <div className="flex items-center justify-between bg-white p-3">
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={currentSelectAll}
              onChange={e => handleSelectAllChange(e.target.checked)}
              className="h-4 w-4"
              ref={input => {
                if (input) {
                  input.indeterminate = isIndeterminate;
                }
              }}
            />
            <span className="text-sm text-[#1F1F1F]">全选</span>
          </div>
          <div className="flex gap-2">
            <button className="rounded bg-gradient-to-r from-[#5D2BC7] to-[#A644CA] px-2 py-1 text-sm text-white shadow-sm">
              发送
            </button>
            <button className="rounded border border-[#5959EB] px-2 py-1 text-sm text-[#5959EB]">
              导出
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
